import { usePublicPanel } from "../api";

export default () => {
  const panel = usePublicPanel();
  return (
    <div className="terms">
      <h1 className="banner">Privacy Policy</h1>
      <div
        dangerouslySetInnerHTML={{
          __html:
            panel.data?.portalBranding?.privacyPolicy ||
            `View Flex's <a href="https://flexwms.co.uk/privacy">Privacy Policy</a>`,
        }}
      />
    </div>
  );
};
